import type { RefObject } from 'preact/compat';

export enum FILE_UPLOAD_STATUS {
  Uploaded = 'Uploaded',
  Error = 'Error',
}

export interface UploadEntry {
  name: string;
  status: FILE_UPLOAD_STATUS;
  error: string | null;
  uploaded?: UploadedFileData;
}

export enum CheckResult {
  /** Расширение не поддерживается (задается для каждого бю) */
  FailedExtension = 'FAILED_EXTENSION',
  /** Некорректный размер файла */
  FailedSize = 'FAILED_SIZE',
  /** Некорректный размер файла */
  FailedTotalSize = 'FAILED_TOTAL_SIZE',
  /** Файл загружен, но не проверялся */
  NotChecked = 'NOT_CHECKED',
  /** Файл загружен и прошел проверку */
  Passed = 'PASSED',
}

export interface UploadedFileData {
  url: string;
  checkResult: CheckResult;
}

interface UploadResultValue {
  status: FILE_UPLOAD_STATUS;
  uploaded?: UploadedFileData;
  error?: string | null;
}

export type UploadResult = {
  status: 'fulfilled' | 'rejected';
  file: File;
  value?: UploadResultValue;
  reason?: unknown;
};

/** В таком формате их хочет видеть бэкенд / приходят по WS */
export interface AttachedFile {
  fileName: string;
  url: string | null;
  contentType: string;
  size: number;
}

/** А в таком формате картинки загрузятся*/
export interface UploadedFileType extends AttachedFile {
  name: string;
  type: string;
  size: number;
  uploadStatus?: CheckResult;
}

export interface UploadFiles {
  success: UploadResult[];
  rejected: UploadResult[];
}

export type UseUploadFilesReturn = {
  isUpLoading: boolean;
  fileInputRef: RefObject<HTMLInputElement>;
  uploadedFiles: UploadFiles;
  attachmentsData: UploadedFileType[];
  handleFilesChange: (event: HTMLInputEvent) => void;
  setSelectedFilesFromInput: (elem: HTMLInputElement) => void;
  removeFile: (fileName: string) => void;
  resetUploader: () => void;
  retryUploadFile: (fileName: string) => Promise<void>;
  isFileUploading: (fileName: string) => boolean;
  handleSetSelectedFiles: (files: File[]) => void;
};

export interface HTMLInputEvent extends Event {
  target: HTMLInputElement & EventTarget;
}

export enum FileType {
  Image = 'image',
  File = 'file',
}

export type LimitType = 'count' | 'size' | 'all';
